<template>
  <div @click="onClick">
    <div class="combo-card" :style="{
      borderColor: checked ? '#409EFF' : ''
    }">
      <div
        class="combo-title"
      >
        <div>{{ value.comboName }}</div>
        <el-tooltip
            class="item"
            effect="dark"
            :content="`商品最高售价￥${value.maxLimitPrice}`"
            placement="top"
        >
          <i class="el-icon-info"></i></el-tooltip>
      </div>
      <div class="combo-content">
        <div class="combo-index">
          <div class="combo-index-label">方案编码</div>
          <div class="combo-index-value">{{ value.index }}</div>
        </div>
        <div class="combo-grid">
          <div>首付租金 ￥{{ value.prepayRentPrice }}</div>
          <div>设备锁 ￥{{ value.lockPrice }}</div>
          <div>每期租金 ￥{{ (value.leftRentPrice / value.leftBillNum).toFixed(2) }}</div>
          <div>剩余期数 {{ value.leftBillNum }}期</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CmoboGradeToColorMap } from "@/enum/dict/combo";
export default {
  name: "ComboCard",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CmoboGradeToColorMap,
    };
  },
  methods: {
    onClick() {
      this.$emit("checkedChange");
    },
  },
};
</script>

<style lang="scss" scoped>
.combo-card {
  border: 2px solid transparent;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0px 2px 8px  rgba(0, 0, 0, 0.15);
  background-color: #F5F5F5;
  overflow: hidden;
  padding: 8px;
  color: #000;
}

.combo-title {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  gap: 6px;
  background-color: #ffffff;
  margin-bottom: 10px;
  border-radius: 12px;
  font-size: 16px;
}

.combo-row {
  width: 100%;
  display: flex;
}

.combo-item {
  display: flex;
  flex: 1;
  height: 34px;
  // border-top: 1px solid #ddd;
  font-size: 13px;

  // &:not(:last-child) {
  //   border-right: 1px solid #ddd;
  // }

  & > div {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #ddd;
  gap: 8px;
  padding: 8px 0;

  .combo-name {
    max-width: 220px;
  }
}

.radio {
  margin-right: 0;
  /deep/ {
    .el-radio__label {
      display: none;
    }
  }
}

.large-combo-value {
  font-size: 16px;
  font-weight: bold;
}

.bold-combo-value {
  font-weight: bold;
}

.combo-content {
  display: flex;
  gap: 8px;

  .combo-index {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 84px;
    background-color: #ffffff;
    border-radius: 12px;
    .combo-index-label {
      margin-bottom: 10px;
    }

    .combo-index-value {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .combo-grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 70px;
    background-color: #ffffff;
    border-radius: 12px;
    font-weight: bold;
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
